import { API } from '@/modules/api-service/api-service';
import type { Data, Core } from '@strapi/types';

const url = '/projects';

export const getProjects = async (title?: Pick<Data.Entity<'api::project.project'>, 'title'>['title'], sort?: string) => {
	const { data: response } = await API().post<
		Core.Helpers.Controllers.GetResponseBody<'api::project.project', 'getProjects'>,
		Core.Helpers.Controllers.GetRequestBody<'api::project.project', 'getProjects'>
	>(url, { sort, title });

	return response;
};

export const createProjectApi = async (body: Core.Helpers.Controllers.GetRequestBody<'api::project.project', 'create'>) => {
	return await API().post(`${url}/create`, body);
};

export const editProjectApi = async ({
	documentId,
	body,
}: {
	documentId: Pick<Data.Entity<'api::project.project'>, 'documentId'>['documentId'];
	body: Core.Helpers.Controllers.GetRequestBody<'api::project.project', 'update'>;
}) => {
	return await API().put<
		Core.Helpers.Controllers.GetResponseBody<'api::project.project', 'update'>,
		Core.Helpers.Controllers.GetRequestBody<'api::project.project', 'update'>
	>(`${url}/update/${documentId}`, body);
};

export const deleteProjectApi = async ({
	documentId,
}: {
	documentId: Pick<Data.Entity<'api::project.project'>, 'documentId'>['documentId'];
}) => {
	return await API().delete(`${url}/delete/${documentId}`);
};
